/*
 * @Author: your name
 * @Date: 2021-03-17 10:08:21
 * @LastEditTime: 2025-11-24 14:56:31
 * @LastEditors: luojing 1286934653@qq.com
 * @Description: add sdkappid
 * @FilePath: \jyh5\src\constans\urlConstans.js
 */
var developName = "prodHY"; //test 测试  prod 正式   testHY 测试虎耀  prodHY 正式虎耀  虎耀云灰度 testHYGray
var versionNo = "";
var urlMap = {
    test: "https://platform.jymeditech.com:12212",//
    // test: "https://platform.jymeditech.com:11212",//
    prod: "https://platform.jymeditech.com:11212",
    testHY: "https://platform-test.jy-meditech.com:11212",
    prodHY: "https://jy-meditech.com:10212",
    testHYGray: "https://platform-gray.jy-meditech.com:1884",
};

var baseUrl = urlMap[developName];

// 公卫版-s
// 测试
// const URL_SERVICE = "https://platform.jymeditech.com:12212"; //其他服务
const URL_SERVICE = baseUrl; //其他服务
var theLanguage; //语言
// 公卫版-e
// 正式
let PROD_SERVICE;
switch (developName) {
    case "test":
        // PROD_SERVICE = "https://platform.jymeditech.com:12212";//测试数据库连不上 暂时用正式
        PROD_SERVICE = "https://platform.jymeditech.com:11212";
        versionNo = "JYAGREEMENT_CN_v1.0.0_ALPHA_20250509";
        theLanguage = "zh";
        break;
    case "prod":
        PROD_SERVICE = "https://platform.jymeditech.com:11212";
        versionNo = "JYAGREEMENT_CN_v1.0.1_ALPHA_20251124";
        theLanguage = "zh";
        break;
    case "testHY":
        PROD_SERVICE = "https://platform-test.jy-meditech.com:11212";
        versionNo = "JYAGREEMENT_TW_v1.0.0.1_20250813";
        theLanguage = "tc";
        break;
    case "prodHY":
        PROD_SERVICE = "https://jy-meditech.com:10212";
        versionNo = "JYAGREEMENT_TW_v1.0.2_20251124";
        theLanguage = "tc";
        break;
    case "testHYGray":
        PROD_SERVICE = "https://platform-gray.jy-meditech.com:1884";
        versionNo = "JYAGREEMENT_TW_v1.0.1_Gray_20250820";
        theLanguage = "tc";
        break;
    default:
        break;
}
const COMMAPP_URL = "https://platform.jymeditech.com:8083/jycloud"; //健康报告
// const COMMAPP_URL = "http://192.168.20.114:8888" //健康报告
const VERSION_NUM = versionNo;

export {
    URL_SERVICE,
    PROD_SERVICE,
    COMMAPP_URL,
    COMM_SERVICE,
    developName,
    VERSION_NUM,
    theLanguage as DEFAULTLANG,
};



// WEBPACK FOOTER //
// ./src/constans/urlConstans.js